import {OfferType} from "@pg-rp/common-types";

import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {getCountriesList} from "../../region/utils/get_countries_list";
import {VendorDetailActiveOffersPageSize} from "../constants/VendorDetailActiveOffersPageSize";
import {IVendorDetailOfferListParams} from "../types/IVendorDetailOfferListParams";

export function convertToVendorDetailViewOffersPayload(params: {vendorId: number | null; region: number | null; displayType: OfferDisplayType}) {
    const {vendorId, region, displayType} = params;

    const fullQuery: IVendorDetailOfferListParams = {
        vendor: vendorId,
        page_size: VendorDetailActiveOffersPageSize,
        country: getCountriesList(),
        ...(region !== null ? {region} : {}),
        display_type: displayType,
        limited_presentation: displayType === OfferDisplayType.FOR_SALE ? false : undefined,
        type: [OfferType.FLAT, OfferType.HOUSE],
        is_active: true
    };

    return fullQuery;
}
import {OfferType} from "@pg-rp/common-types";

import {OfferDisplayType} from "../../offer/helpers/OfferDisplayType";
import {getCountriesList} from "../../region/utils/get_countries_list";
import {VendorDetailActiveOffersPageSize} from "../constants/VendorDetailActiveOffersPageSize";
import {IVendorDetailOfferListParams} from "../types/IVendorDetailOfferListParams";

export function convertToVendorDetailViewOffersPayload(params: {vendorId: number | null; region: number | null; displayType: OfferDisplayType}) {
    const {vendorId, region, displayType} = params;

    const fullQuery: IVendorDetailOfferListParams = {
        vendor: vendorId,
        page_size: VendorDetailActiveOffersPageSize,
        country: getCountriesList(),
        ...(region !== null ? {region} : {}),
        display_type: displayType,
        limited_presentation: displayType === OfferDisplayType.FOR_SALE ? false : undefined,
        type: [OfferType.FLAT, OfferType.HOUSE],
        is_active: true
    };

    return fullQuery;
}
